/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';
import Image from '@web/components/common/Image';
import Colors from '~global/Colors';

import { useSelector, useDispatch } from 'react-redux';
import { isWeb } from '~global/screens';

const ItemCombination = ({ combinationGroup, index, navigation }) => {
  const dispatch = useDispatch();
  const selectedProduct = useSelector(
    (state) => state.createReview.selectedProduct,
  );
  const reviewInSpecificProduct = useSelector(
    (state) => state.createReview.reviewInSpecificProduct,
  );
  const [isReviewed] = useState(
    Boolean(
      reviewInSpecificProduct.find(
        (review) => review.product.combination.id === combinationGroup['_id'],
      ),
    ),
  );
  const isReviewDisabled = combinationGroup?.is_reviewed || isReviewed;
  const selectCombinationGroupHandler = (index) => {
    const copySelectedProduct = { ...selectedProduct };
    copySelectedProduct.currentCombination =
      copySelectedProduct.combinations[index];

    dispatch({
      type: 'createReview/setState',
      name: 'selectedIndexCombination',
      value: index,
    });
    dispatch({
      type: 'createReview/setState',
      name: 'selectedProduct',
      value: copySelectedProduct,
    });
    if (isWeb) {
      dispatch({ type: 'MODAL/HIDE', modalName: 'addReviewRecentlyBought' });
      return navigation.navigate('CreateReviewScreenDesktop', {
        id: selectedProduct.id,
        combinationName: combinationGroup?.name,
      });
    }

    dispatch({
      type: 'createReview/setState',
      name: 'section',
      value: 'give_rating',
    });
  };

  const VerifiedIcon = () => {
    if (isWeb) {
      return (
        <View style={styles.verifiedReviewWrapper}>
          <Image
            source={require('~assets/img/product-detail/verified-icon.png')}
            style={styles.iconVerified}
          />
          <Text style={styles.trustedReviewText}>TRUSTED REVIEW</Text>
        </View>
      );
    }

    return (
      <View>
        <Image
          source={require('~assets/img/product-detail/verified-icon.png')}
          style={styles.iconVerified}
        />
      </View>
    );
  };
  return (
    <TouchableOpacity
      onPress={() => {
        selectCombinationGroupHandler(index);
      }}
      style={{
        ...(isReviewDisabled ? { opacity: 0.5 } : {}),
      }}
      disabled={isReviewDisabled}>
      <View style={styles.combination}>
        <View style={styles.combinationLeftSide}>
          {combinationGroup.is_contains_shade && (
            <>
              {combinationGroup.shade.url ? (
                <Image
                  source={{ uri: combinationGroup.shade.url }}
                  style={styles.combinationShadeImage}
                />
              ) : (
                <View
                  style={[
                    styles.combinationShadeImage,
                    { backgroundColor: combinationGroup.shade.hex },
                  ]}></View>
              )}
            </>
          )}
          <Text
            style={[
              styles.combinationGroupName,
              isReviewed ? { color: '#AEAEAE' } : {},
            ]}>
            {combinationGroup.name}
          </Text>
        </View>

        <View style={styles.combinationRightSide}>
          {combinationGroup.is_verified_purchase && !isReviewed ? (
            <VerifiedIcon />
          ) : null}

          {isReviewDisabled ? (
            <Text style={styles.textVerified}> Reviewed</Text>
          ) : null}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  combination: {
    paddingHorizontal: 16,
    height: 50,
    justifyContent: 'space-between',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#F2F2F2',
  },
  combinationLeftSide: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  combinationRightSide: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  combinationGroupName: {
    fontFamily: 'figtree-medium',
    fontSize: 14,
    lineHeight: 18,
    color: '#333333',
  },
  combinationShadeImage: {
    height: 24,
    width: 24,
    borderRadius: 12,
    marginRight: 14,
  },
  iconVerified: {
    width: 16,
    height: 15,
  },
  textVerified: {
    fontFamily: 'figtree-black',
    fontSize: 11,
    lineHeight: 14,
    letterSpacing: 0,
    color: '#F05B68',
  },
  verifiedReviewWrapper: {
    flexDirection: 'row',
    backgroundColor: Colors.grey13,
    borderRadius: 13,
    padding: 4,
  },
  trustedReviewText: {
    textTransform: 'capitalize',
    fontSize: 12,
  },
});

export default ItemCombination;
